import {StyleSheet, Platform} from 'react-native';
import {mvs} from '../../../util/metrices';
import colors from '../../../util/colors';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  header: {
    backgroundColor: colors.primary,
    paddingTop: mvs(20),
    paddingBottom: mvs(20),
    paddingHorizontal: mvs(20),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  backButton: {
    padding: mvs(8),
  },
  headerTitle: {
    fontSize: Platform.OS === 'web' ? 28 : mvs(20),
    color: colors.antiqueWhite,
    flex: 1,
    textAlign: 'center',
    fontWeight: Platform.OS === 'web' ? '700' : 'normal',
    letterSpacing: Platform.OS === 'web' ? 0.5 : 0,
    lineHeight: Platform.OS === 'web' ? 36 : undefined,
  },
  headerRight: {
    width: mvs(40),
  },
  searchContainer: {
    paddingHorizontal: mvs(20),
    paddingVertical: mvs(15),
    backgroundColor: colors.antiqueWhite,
    borderBottomWidth: 1,
    borderBottomColor: colors.ecru,
  },
  searchInput: {
    backgroundColor: colors.background,
    paddingHorizontal: mvs(15),
    paddingVertical: mvs(12),
    borderRadius: mvs(10),
    fontSize: mvs(16),
    color: colors.taupe,
    borderWidth: 1,
    borderColor: colors.ecru,
  },
  searchIcon: {
    position: 'absolute',
    right: mvs(35),
    top: mvs(27),
  },
  filterContainer: {
    backgroundColor: colors.antiqueWhite,
    paddingVertical: mvs(10),
    borderBottomWidth: 1,
    borderBottomColor: colors.ecru,
  },
  filterScrollContainer: {
    paddingHorizontal: mvs(20),
    gap: mvs(10),
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: mvs(14),
    paddingVertical: mvs(10),
    borderRadius: mvs(25),
    backgroundColor: colors.background,
    borderWidth: 1,
    borderColor: colors.ecru,
    gap: mvs(8),
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  filterButtonActive: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
    shadowOpacity: 0.2,
    shadowRadius: 6,
    elevation: 4,
  },
  filterButtonText: {
    fontSize: mvs(14),
    color: colors.kobicha,
  },
  filterButtonTextActive: {
    color: colors.antiqueWhite,
  },
  resultsContainer: {
    paddingHorizontal: mvs(20),
    paddingVertical: mvs(10),
    backgroundColor: colors.antiqueWhite,
  },
  resultsText: {
    fontSize: mvs(14),
    color: colors.lion,
  },
  flatList: {
    flex: 1,
  },
  listContainer: {
    padding: mvs(20),
  },
  devotionItemContainer: {
    marginBottom: mvs(20),
    borderRadius: mvs(16),
    overflow: 'hidden',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 8,
    },
    shadowOpacity: 0.3,
    shadowRadius: 12,
    elevation: 8,
  },
  devotionGradient: {
    width: '100%',
    position: 'relative',
  },
  darkOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
  },
  cornerDecoration: {
    position: 'absolute',
    top: mvs(15),
    right: mvs(15),
    opacity: 0.4,
  },
  cornerText: {
    fontSize: mvs(20),
    color: '#FFFFFF',
    textShadowColor: 'rgba(0, 0, 0, 0.8)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  devotionContent: {
    padding: mvs(20),
  },
  devotionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: mvs(15),
  },
  devotionDate: {
    fontSize: Platform.OS === 'web' ? 16 : mvs(14),
    color: '#FFFFFF',
    textShadowColor: 'rgba(0, 0, 0, 0.7)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    fontWeight: '600',
    letterSpacing: Platform.OS === 'web' ? 0.2 : 0,
  },
  devotionNumber: {
    backgroundColor: colors.antiqueWhite,
    paddingHorizontal: mvs(10),
    paddingVertical: mvs(6),
    borderRadius: mvs(15),
  },
  devotionNumberText: {
    fontSize: Platform.OS === 'web' ? 14 : mvs(12),
    color: colors.kobicha,
    fontWeight: 'bold',
  },
  devotionTitle: {
    fontSize: Platform.OS === 'web' ? 24 : mvs(20),
    color: '#FFFFFF',
    marginBottom: Platform.OS === 'web' ? 16 : mvs(12),
    lineHeight: Platform.OS === 'web' ? 32 : mvs(26),
    textShadowColor: 'rgba(0, 0, 0, 0.8)',
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 4,
    fontWeight: 'bold',
  },
  devotionPreview: {
    fontSize: Platform.OS === 'web' ? 18 : mvs(15),
    color: '#FFFFFF',
    lineHeight: Platform.OS === 'web' ? 28 : mvs(22),
    textShadowColor: 'rgba(0, 0, 0, 0.7)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 3,
    fontWeight: Platform.OS === 'web' ? '400' : '500',
    marginBottom: Platform.OS === 'web' ? 18 : mvs(10),
  },
  devotionFooter: {
    alignItems: 'flex-end',
    marginTop: mvs(15),
  },
  readMoreContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    paddingHorizontal: mvs(12),
    paddingVertical: mvs(8),
    borderRadius: mvs(20),
    gap: mvs(6),
  },
  readMoreText: {
    fontSize: Platform.OS === 'web' ? 16 : mvs(14),
    color: '#FFFFFF',
    fontWeight: '600',
    textShadowColor: 'rgba(0, 0, 0, 0.8)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    letterSpacing: Platform.OS === 'web' ? 0.2 : 0,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: mvs(20),
  },
  loadingText: {
    fontSize: mvs(16),
    color: colors.lion,
    marginTop: mvs(15),
    textAlign: 'center',
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: mvs(20),
  },
  errorTitle: {
    fontSize: mvs(20),
    color: colors.kobicha,
    marginTop: mvs(15),
    marginBottom: mvs(10),
    textAlign: 'center',
  },
  errorText: {
    fontSize: mvs(16),
    color: colors.lion,
    textAlign: 'center',
    lineHeight: mvs(24),
    marginBottom: mvs(25),
  },
  retryButton: {
    backgroundColor: colors.primary,
    paddingHorizontal: mvs(25),
    paddingVertical: mvs(12),
    borderRadius: mvs(25),
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  retryButtonText: {
    fontSize: mvs(16),
    color: colors.antiqueWhite,
    fontWeight: '600',
  },
  loadMoreContainer: {
    paddingVertical: mvs(20),
    alignItems: 'center',
  },
  loadMoreButton: {
    backgroundColor: colors.primary,
    paddingHorizontal: mvs(25),
    paddingVertical: mvs(12),
    borderRadius: mvs(25),
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  loadMoreText: {
    fontSize: mvs(16),
    color: colors.antiqueWhite,
    fontWeight: '600',
  },
});

export default styles; 